import { Stack } from '@mui/material';
import { useIsMobile } from '@side/pantry';
import { SectionContainer } from '../SectionContainer';
import { LastViewed, SearchAllTransactionsContainer } from './components';

export function TransactionSearchLastViewed() {
  const isMobile = useIsMobile('md');

  return (
    <SectionContainer data-testid="txm-home-search-transactions-section">
      <Stack
        direction={isMobile ? 'column' : 'row'}
        spacing={{ xs: 4, md: 5 }}
        sx={{ justifyContent: 'space-between' }}
      >
        <SearchAllTransactionsContainer />
        <LastViewed />
      </Stack>
    </SectionContainer>
  );
}
